"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.payAndTicketReservation = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const actionLayout_1 = require("../../../../Table/columns/actionsColumn/actionLayout");
const views = {
    pay: {
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Actions:Payment', defaultMessage: 'Payment' })),
        iconName: 'dollar-circle-thin',
        targetOption: 'pay',
    },
    ticket: {
        text: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/Column/Actions:Ticket', defaultMessage: 'Ticket' })),
        iconName: 'document',
        targetOption: 'ticket',
    },
};
exports.payAndTicketReservation = (0, actionLayout_1.createActionLayout)((state) => views[state]);
//# sourceMappingURL=payAndTicketReservation.js.map